import { get, post, put } from './serviceHelper'
let host = '/ucenter/api/v1/'
//模块列表
export const modules = () => get(`${host}Product/modules`, {}).then((res) => res)
//版本列表
export const editions = (parmas) => get(`${host}Product/editions`, parmas).then((res) => res)
// 商品列表
export const goods = (parmas) => get(`${host}Product/goods`, parmas).then((res) => res)
//商品详情
export const Detail = (parmas) => get(`${host}Product/goods/Detail`, parmas).then((res) => res)
//订单列表
export const Order = (parmas) => get(`${host}Order`, parmas, false).then((res) => res)
//创建订单
export const create = (parmas) => post(`${host}Order/create`, parmas).then((res) => res)
//订单详情
export const opderDetail = (parmas) => get(`${host}Order/detail`, parmas).then((res) => res)
//查询支付状态
export const Payinfo = (parmas) => get(`${host}Pay/info`, parmas, false).then((res) => res)
//区域列表
export const regions = (parmas) => get(`${host}Hold/regions`, parmas).then((res) => res)
//规格列表
export const specification = (parmas) => get(`${host}Hold/specification`, parmas).then((res) => res)
//创建云主机
export const liteEcs = (parmas) => post(`${host}Hold/lite/Ecs`, parmas).then((res) => res)
//优惠劵列表
export const Coupon = (parmas) => get(`${host}Coupon`, parmas).then((res) => res)
//获取token
export const getTokenByErp = (parmas) => get(`${host}getTokenByErp`, parmas).then((res) => res)
//使用优惠劵
export const usage = (parmas) => get(`${host}Coupon/usage`, parmas).then((res) => res)
//服务器价格列表
export const Price = (parmas) => post(`${host}Hold/ecs/Price`, parmas).then((res) => res)
//交易明细
export const Flow = (parmas) => get(`${host}Balance/transaction/Flow`, parmas).then((res) => res)
//发起支付
export const Pay = (parmas) => get(`${host}Pay`, parmas).then((res) => res)
//账户信息
export const userInfo = (parmas) => get(`${host}Account/info`, parmas).then((res) => res)
//领取优惠券
export const receive = (parmas) => get(`${host}Coupon/receive`, parmas).then((res) => res)
//账户资源信息
export const resource = (parmas) => get(`${host}Account/resource`, parmas).then((res) => res)
// /取消订单
export const cancel = (parmas) => get(`${host}Order/cancel`, parmas).then((res) => res)
// 扣单详情
export const deductionDetail = (parmas) => get(`${host}Account/deductionDetail`, parmas).then((res) => res)
/**用户停留时间记录接口 */
export const remainPage = (parmas) => get(`${host}remainPage`, parmas, false).then((res) => res)
/**获取员工列表 */
export const emloyeeList = (parmas) => get(`${host}company/emloyeeList`, parmas).then((res) => res)
/**设置服务器可见员工 */
export const setServerOption = (parmas) => put(`${host}company/setServerOption`, parmas).then((res) => res)
/**获取服务器升级带宽价格 */
export const publicipPrice = (parmas) => get(`${host}Hold/ecs/publicip/price`, parmas)
/**升级带宽创建订单 */
export const publicipOrder = (parmas) => put(`${host}Hold/ecs/publicip`, parmas)
/**获取规格镜像列表 */
export const ecsImage = (parmas) => get(`${host}Hold/ecsImage`, parmas)
/**获取物流账单列表 */
export const getLogistics = (parmas) => get(`${host}logistics/Order`, parmas)
/**获取物流账单详情 */
export const getLogisticsInfo = (parmas) => get(`${host}logistics/OrderInfo`, parmas)
/**服务器续费获取价格 */
export const renewPrice = (parmas) => post(`${host}Hold/ecs/renew/price`, parmas)
/**续费服务器创建订单 */
export const createRenewOrder = (parmas) => post(`${host}Hold/ecs/renew`, parmas)
/**获取服务器资源列表 */
export const getServeResource = (parmas) => get(`${host}Account/ecsServer`, parmas)
/**批量续费服务器创建订单 */
export const createRenewBatch = (parmas) => post(`${host}Hold/ecs/renew/batch`, parmas)
/**服务器批量续费获取价格 */
export const getRenewBatchPrice = (parmas) => post(`${host}Hold/ecs/renew/batch/price`, parmas)
/**推送shopify支付回调信息给后台 */
export const postShopifyPayInfo = (parmas) => get(`${host}Pay/notifyShopify`, parmas)
